import { useMutation, useQuery } from '@tanstack/react-query';
import { errorHandler } from 'utils/errors';
import { getTnCByFeatures, postTnCAcceptances } from './termsAndConditions';
import { TnCFeaturesIDEnum } from '../types/termsAndCondition';
import { AcceptancesPayload } from '../types/api/termsAndConditions';

export const useGetTncByFeatures = (featureIds: TnCFeaturesIDEnum[]) => {
  const query = useQuery({
    queryKey: ['tnc-features', featureIds],
    queryFn: async () => {
      const response = await getTnCByFeatures(featureIds);
      return response.data.data;
    },
    onError: (error) => {
      errorHandler(error, 'Failed to load TnC features');
    },
    cacheTime: 1 * 60 * 1000, // 1 minute
  });

  return query;
};

export const useAcceptTnc = () => {
  const mutation = useMutation({
    mutationFn: async (payload: AcceptancesPayload[]) =>
      (await postTnCAcceptances(payload)).data,
    onError: (error) => {
      errorHandler(error, 'Failed to accept TnC');
      return undefined;
    },
    retry: false,
  });
  return mutation;
};
